import { type ReactElement } from 'react';
import { Spinner } from '@avanta/shared/components/ui/Spinner';
import { cn } from '@avanta/shared/utils/cn';

export const LoadingScreen = ({ fullScreen = false }: { fullScreen?: boolean }): ReactElement => (
  <div className={cn(`flex flex-col h-100 items-center justify-center`, fullScreen && `h-screen`)}>
    <Spinner />
  </div>
);
